import type { GroupedInvitation, MyInvitation } from "../types";

export const groupInvitationsByProject = (
  items: MyInvitation[]
): GroupedInvitation[] => {
  const grouped = items.reduce<Record<string, GroupedInvitation>>(
    (acc, invitation) => {
      const projectId = invitation.project_id;
      const existingGroup = acc[projectId];

      if (existingGroup) {
        const currentExpiration = new Date(existingGroup.expires_at).getTime();
        const nextExpiration = new Date(invitation.expires_at).getTime();

        // Use the invitation with the latest expiration date
        if (nextExpiration > currentExpiration) {
          existingGroup.expires_at = invitation.expires_at;
          existingGroup.primary_invitation_id = invitation.invitation_id;
        }

        existingGroup.inviters.push({
          invitation_id: invitation.invitation_id,
          name: invitation.inviter_name,
          email: invitation.inviter_email,
        });
      } else {
        acc[projectId] = {
          project_id: projectId,
          project_name: invitation.project_name,
          org_id: invitation.org_id,
          org_name: invitation.org_name,
          expires_at: invitation.expires_at,
          primary_invitation_id: invitation.invitation_id,
          inviters: [
            {
              invitation_id: invitation.invitation_id,
              name: invitation.inviter_name,
              email: invitation.inviter_email,
            },
          ],
        };
      }

      return acc;
    },
    {}
  );

  return Object.values(grouped);
};
